import React, {useState} from 'react'
import { Component } from "react";
import Slider from "react-slick";
import './gallerycontent.less'
// import {SRLWrapper} from 'simple-react-lightbox'

// IMAGES IMPORTS
import one from '../../../images/Hero-About.jpg'
import two from '../../../images/2.jpg'
import three from '../../../images/4.jpg'
import four from '../../../images/5.jpg'
import five from '../../../images/6.jpg'
import six from '../../../images/7.jpg'
import seven from '../../../images/8.jpeg'
import eight from '../../../images/9.jpg'
import nine from '../../../images/10.jpg'
import ten from '../../../images/12.jpg'
import eleven from '../../../images/13.jpg'
import twelve from '../../../images/14.jpg'
import thirteen from '../../../images/15.jpg'
import fourteen from '../../../images/16.jpg'
import fifteen from '../../../images/17.jpg'
import sixteen from '../../../images/18.jpg'
import seventeen from '../../../images/19.jpg'
import eighteen from '../../../images/20.jpg'
import nineteen from '../../../images/21.jpg'
import twenty from '../../../images/22.jpg'
import twentyone from '../../../images/23.jpg'
import twentytwo from '../../../images/24.jpg'
import twentythree from '../../../images/25.jpg'
import twentyfour from '../../../images/26.jpg'
import twentyfive from '../../../images/27.jpg'
import twentysix from '../../../images/28.jpg'
import twentyseven from '../../../images/29.jpg'
import twentyeight from '../../../images/30.jpg'
import twentynine from '../../../images/31.jpg'
import thirty from '../../../images/32.jpg'
import thirtyone from '../../../images/33.jpg'

const images = [
        { id: 1, imageName: one },
        { id: 2, imageName: two },
        { id: 3, imageName: three },
        { id: 4, imageName: four },
        { id: 5, imageName: five },
        { id: 6, imageName: six },
        { id: 7, imageName: seven },
        { id: 8, imageName: eight },
        { id: 9, imageName: nine },
        { id: 10, imageName: ten },
        { id: 11, imageName: eleven },
        { id: 12, imageName: twelve },
        { id: 13, imageName: thirteen },
        { id: 14, imageName: fourteen },
        { id: 15, imageName: fifteen },
        { id: 16, imageName: sixteen },
        { id: 17, imageName: seventeen },
        { id: 18, imageName: eighteen },
        { id: 19, imageName: nineteen },
        { id: 20, imageName: twenty },
        { id: 21, imageName: twentyone },
        { id: 22, imageName: twentytwo },
        { id: 23, imageName: twentythree },
        { id: 24, imageName: twentyfour },
        { id: 25, imageName: twentyfive },
        { id: 26, imageName: twentysix },
        { id: 27, imageName: twentyseven },
        { id: 28, imageName: twentyeight },
        { id: 29, imageName: twentynine },
        { id: 30, imageName: thirty },
        { id: 31, imageName: thirtyone },
    ]

export default class AsNavFor extends Component {
    constructor(props) {
        super(props);
            this.state = {
                nav1: null,
                nav2: null
            };
    }

    componentDidMount() {
        this.setState({
            nav1: this.slider1,
            nav2: this.slider2
        });
    }

    render() {
        return (
            <section className="gallery-content">
                <article className="gallery-description">
                    <h4 className="sub-heading event-title">
                        <span className="sub-event-title">
                            Garage Sale
                        </span>
                        <span className="sub-event-title">
                            19/12/2020
                        </span>
                    </h4>
                    <p className="event-info">
                        The inaugural garage sale by the empower initiative was held on the <span
                            className="event-info-date">19<sup>th</sup> of December 2020</span>. This event was held to raise money to support single
                        parents in need for Christmas. We would also like to thank who volunteered to help out, and visited us
                        at this event. Your contributions made a difference.
                    </p>
                </article>
                    {/* <article className="image-gallery"> */}
                    <div className="main-slick">
                        <Slider
                            asNavFor={this.state.nav2}
                            ref={slider => (this.slider1 = slider)}
                            autoplay={true}
                            autoplaySpeed ={4000}
                            lazyLoad = {true}
                            fade={true}
                            >
                            {images.map(image=>{
                                return <SetImage key={image.id} id={image.id} imageName={image.imageName}/>
                            }
                            )}
                        </Slider>
                    </div>
                    {/* </article> */}
                    {/* <article className="image-gallery"> */}
                    <div className="nav-slick sm">
                        <Slider
                            asNavFor={this.state.nav1}
                            ref={slider => (this.slider2 = slider)}
                            slidesToShow={3}
                            swipeToSlide={true}
                            focusOnSelect={true}
                            autoplay={true}
                            autoplaySpeed ={4000}
                            lazyLoad = {true}
                            cssEase={'ease-in-out'}
                            // fade={true}
                            >
                            {images.map(image=>{
                                return <SetImage key={image.id} id={image.id} imageName={image.imageName}/>
                            }
                            )}
                        </Slider>
                    </div>
                    <div className="nav-slick lg">
                        <Slider
                            asNavFor={this.state.nav1}
                            ref={slider => (this.slider2 = slider)}
                            slidesToShow={6}
                            swipeToSlide={true}
                            focusOnSelect={true}
                            autoplay={true}
                            autoplaySpeed ={4000}
                            lazyLoad = {true}
                            cssEase={'ease-in-out'}
                            // fade={true}
                            >
                            {images.map(image=>{
                                return <SetImage key={image.id} id={image.id} imageName={image.imageName}/>
                            }
                            )}
                        </Slider>
                    </div>
                    {/* </article> */}
            </section>
        );
  }
}

const SetImage = ({id, imageName})=>{
    const openModal = (e)=>{
        console.log(e.currentTarget.id);
        let img = images.filter(image => image.id === id);
    }
    return(
        <div className="single-slick" key={id} id={id} onClick={(e)=>openModal(e)}>
            <img src={imageName}  alt={imageName}/>
        </div>
    )
}
